// extracted by mini-css-extract-plugin
export default {"search-bar-container":"EmptySeat_search-bar-container__0y8Sw","empty-seat":"EmptySeat_empty-seat__uNf9S","title":"EmptySeat_title__5UYI+"};